import { render, staticRenderFns } from "./FormExpired.vue?vue&type=template&id=77a8d00c"
import script from "./FormExpired.vue?vue&type=script&lang=ts"
export * from "./FormExpired.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports